import { render, staticRenderFns } from "./FbHtmlPackage.vue?vue&type=template&id=0f5cd142&scoped=true"
import script from "./FbHtmlPackage.vue?vue&type=script&lang=js"
export * from "./FbHtmlPackage.vue?vue&type=script&lang=js"
import style0 from "./FbHtmlPackage.vue?vue&type=style&index=0&id=0f5cd142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5cd142",
  null
  
)

export default component.exports